export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9e929c35a1f5bc8812877f46b679b76c.jpg"
          alt="Mali Müşavirlik Ofisi - Özgür Çakmak SMMM"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A2540]/90 via-[#0A2540]/75 to-[#0A2540]/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-32 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left */}
          <div className="flex-1 w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 border border-white/20 rounded-full mb-6">
              <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
              <span className="text-white/80 text-xs font-medium tracking-wide">Serbest Muhasebeci Mali Müşavir · Özgür Çakmak</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Mali Süreçlerinizi<br />
              <span className="text-[#60A5FA]">Güvenle</span><br />
              Yönetin
            </h1>

            <p className="text-white/75 text-base md:text-lg leading-relaxed mb-10 max-w-xl">
              Vergi, muhasebe ve finansal süreçlerinizde doğru ve sürdürülebilir çözümler. Yanınızda bir danışman, her adımda.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => handleScroll('#araclar')}
                className="px-7 py-3.5 bg-white text-[#0A2540] text-sm font-semibold rounded-lg hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap"
              >
                Bilgi Al
              </button>
              <button
                onClick={() => handleScroll('#iletisim')}
                className="px-7 py-3.5 border border-white/40 text-white text-sm font-semibold rounded-lg hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
              >
                İletişime Geç
              </button>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 mt-14 pt-10 border-t border-white/15">
              {[
                { value: '10+', label: 'Yıl Deneyim' },
                { value: '50+', label: 'Aktif Müşteri' },
                { value: '12', label: 'Hizmet Alanı' },
              ].map((stat) => (
                <div key={stat.label}>
                  <div className="text-2xl font-bold text-white">{stat.value}</div>
                  <div className="text-white/60 text-sm mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Card */}
          <div className="hidden lg:block w-[380px] flex-shrink-0">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6">
              <div className="text-white/60 text-xs font-medium uppercase tracking-widest mb-4">Güncel Hatırlatma</div>
              <div className="space-y-3">
                {[
                  { icon: 'ri-calendar-check-line', label: 'KDV Beyannamesi', date: '26 Nisan 2026', color: 'text-emerald-400' },
                  { icon: 'ri-file-text-line', label: 'Muhtasar Beyanname', date: '26 Nisan 2026', color: 'text-[#60A5FA]' },
                  { icon: 'ri-bank-line', label: 'SGK Bildirimi', date: '23 Nisan 2026', color: 'text-amber-400' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-3 p-3 bg-white/5 rounded-xl">
                    <div className={`w-8 h-8 flex items-center justify-center ${item.color}`}>
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-white text-sm font-medium">{item.label}</div>
                      <div className="text-white/50 text-xs">{item.date}</div>
                    </div>
                    <div className="w-2 h-2 rounded-full bg-emerald-400 flex-shrink-0"></div>
                  </div>
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-white/10 text-center">
                <button
                  onClick={() => handleScroll('#araclar')}
                  className="text-white/70 text-xs hover:text-white transition-colors cursor-pointer"
                >
                  Tüm tarihleri gör →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-8 bg-white/30"></div>
        <i className="ri-arrow-down-line text-white/40 text-sm"></i>
      </div>
    </section>
  );
}
